// Home's disposition worklist (G §2 "Disposition worklist; handoff task to Coordinator/HR Ops" — the Step 21 list of
// candidates still to disposition; DC-31 "route Pass to disposition workflow"): the Recruiter's requisitions with
// candidates still open, how many on each, every row opening that requisition. Nothing open is his gate word, *All
// candidates dispositioned*. The rows name requisitions and counts only; no candidate is named on Home.

import { Count, EmptyState, Row, RowName, Stack, Widget } from "@/mc";
import { ACTION_KIND_LABELS, METRIC_LABELS } from "@/mc/g3/labels";
import type { HomeWidgetView } from "./host";
import { dispositionWorklistOf, seatsOf, type DispositionWorklistData } from "./api";
import { HOME_LABELS } from "./labels";
import { hsKey } from "@/views/b10/lib/hsKey";

export function DispositionBody({ data }: { data: DispositionWorklistData }) {
  const rows = data.rows.filter((row) => row.open > 0);
  if (rows.length === 0) return <EmptyState inline>{METRIC_LABELS.allCandidatesDispositioned}</EmptyState>;
  return (
    <Stack gap={0}>
      {rows.map((row) => (
        <Row key={row.requisition_id} cols={2} lead="75%" href={row.route || undefined} hs={hsKey("dash.disposition.req", row.requisition_id)}>
          <RowName name={row.title} sub={row.requisition_id} />
          <Count n={row.open} label={ACTION_KIND_LABELS.candidates} />
        </Row>
      ))}
    </Stack>
  );
}

/** Widget `disposition_worklist` (S13 → S16, frozen; held on the server until C-B10-8). */
export const DispositionWorklist: HomeWidgetView = ({ widgetKey, data }) => {
  const worklist = dispositionWorklistOf(data);
  return (
    <Widget id={widgetKey} kind="sections" roles={seatsOf(widgetKey)} title={HOME_LABELS.dispositionWorklist} count={worklist.open}>
      <DispositionBody data={worklist} />
    </Widget>
  );
};
